import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import Config from "config";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Spinner,
} from "reactstrap";
import Spinners from "components/Common/Spinner";

import Select from "react-select";
import InputMask from "react-input-mask";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import withRouter from "components/Common/withRouter";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

import avatar from "../../assets/images/users/avatar.png";
// actions
import { editProfile, resetProfileFlag } from "../../store/actions";
const UserProfile = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  //meta title
  document.title = "Profile | DOM COM";
  const [loading, setLoading] = useState(true);
  const colStyle = { width: "25em", whiteSpace: "nowrap" };
  const handleNavigate = () => {
    localStorage.setItem("key", true);
    window.location.reload();
  };
  const dispatch = useDispatch();
  const token = localStorage.getItem("auth_token_" + api);
  const [name, setname] = useState("");
  const [idx, setidx] = useState(1);
  // autres variables PP
  const [conseil, setConseil] = useState("");
  const handleConseilChange = (e) => {
    setConseil(e.target.value);
  };

  const [nom, setNom] = useState("");
  const handleNomChange = (e) => {
    setNom(e.target.value);
  };

  const [prenom, setPrenom] = useState("");
  const handlePrenomChange = (e) => {
    setPrenom(e.target.value);
  };

  const [dateNaissance, setDateNaissance] = useState("");
  const handleDateNaissanceChange = (e) => {
    setDateNaissance(e.target.value);
  };

  const [lieuNaissance, setLieuNaissance] = useState("");
  const handleLieuNaissanceChange = (e) => {
    setLieuNaissance(e.target.value);
  };

  const [deptNaissance, setDeptNaissance] = useState("");
  const handleDeptNaissanceChange = (e) => {
    setDeptNaissance(e.target.value);
  };

  const [profession, setProfession] = useState("");
  const handleProfessionChange = (e) => {
    setProfession(e.target.value);
  };

  const [emailPerso, setEmailPerso] = useState("");
  const handleEmailPersoChange = (e) => {
    setEmailPerso(e.target.value);
  };

  const [emailPro, setEmailPro] = useState("");
  const handleEmailProChange = (e) => {
    setEmailPro(e.target.value);
  };

  const [telephoneFixe, setTelephoneFixe] = useState("");
  const handleTelephoneFixeChange = (e) => {
    setTelephoneFixe(e.target.value);
  };

  const [telephoneMobile, setTelephoneMobile] = useState("");
  const handleTelephoneMobileChange = (e) => {
    setTelephoneMobile(e.target.value);
  };

  const [adresseResidence, setAdresseResidence] = useState("");
  const handleAdresseResidenceChange = (e) => {
    setAdresseResidence(e.target.value);
  };

  const [complementAdresse, setComplementAdresse] = useState("");
  const handleComplementAdresseChange = (e) => {
    setComplementAdresse(e.target.value);
  };

  const [codePostalResidence, setCodePostalResidence] = useState("");
  const handleCodePostalResidenceChange = (e) => {
    setCodePostalResidence(e.target.value);
  };

  const [villeResidence, setVilleResidence] = useState("");
  const handleVilleResidenceChange = (e) => {
    setVilleResidence(e.target.value);
  };
  // Titre
  const [titreData, setTitreData] = useState({ data: [] });
  const [selectedTitre, setSelectedTitre] = useState("");
  const renderTitreOptions = () => {
    return [
      {
        options: titreData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /******************* P M ************************/
  const [raisonSocial, setRaisonSocial] = useState("");
  const [contact, setContact] = useState("");
  const [email, setEmail] = useState("");
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const [tel, setTel] = useState("");
  const handleTelChange = (e) => {
    setTel(e.target.value);
  };
  const [fax, setFax] = useState("");
  const handleFaxChange = (e) => {
    setFax(e.target.value);
  };
  const [adresse, setAdresse] = useState("");
  const handleAdresseChange = (e) => {
    setAdresse(e.target.value);
  };
  const [code_postal, setCode_postal] = useState("");
  const handleCode_postalChange = (e) => {
    setCode_postal(e.target.value);
  };
  const [ville, setVille] = useState("");
  const handleVilleChange = (e) => {
    setVille(e.target.value);
  };
  const [pays, setPays] = useState("");
  const handlePaysPMChange = (e) => {
    setPays(e);
  };

  /******************* end P M ********************/
  const handleTitreChange = (e) => {
    setSelectedTitre(e);
  };
  const getTitre = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/titres`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((titre) => {
          setTitreData(titre);
        });
    } catch (error) {
      console.log(error);
    }
  };
  // Pays
  const [selectedPays, setSelectedPays] = useState("");
  const [payData, setPayData] = useState({ data: [] });
  const handlePaysChange = (e) => {
    setSelectedPays(e);
  };
  const renderPayOptions = () => {
    const emptyOption = (
      <option key="empty" value="">
        Sélectionner une option
      </option>
    );

    return [
      {
        options: payData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getPay = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/pays`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pay) => {
          setPayData(pay);
        });
    } catch (error) {
      console.log(error);
    }
  };
  // mes infos
  const [infos, setInfosData] = useState({ data: [] });
  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fdashboards/mes_infos`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        history(`${backUrl}/login`);
        window.location.reload(false);
        // throw new Error("Erreur lors de la récupération des données");
        // rediriger vers le login
      }

      const infosData = await response.json();
      setInfosData(infosData);
      if (infosData.type_personne == "PP") {
        setConseil(infosData?.data[0]);
        setSelectedTitre(infosData?.data[1]);
        setNom(infosData?.data[2]?.value);
        setPrenom(infosData?.data[3]?.value);
        setDateNaissance(infosData?.data[4]?.value);
        setLieuNaissance(infosData?.data[5]?.value);
        setDeptNaissance(infosData?.data[6]?.value);
        setProfession(infosData?.data[7]?.value);
        setEmailPerso(infosData?.data[8]?.value);
        setEmailPro(infosData?.data[9]?.value);
        setTelephoneFixe(infosData?.data[10]?.value);
        setTelephoneMobile(infosData?.data[11]?.value);
        setAdresseResidence(infosData?.data[12]?.value);
        setComplementAdresse(infosData?.data[13]?.value);
        setCodePostalResidence(infosData?.data[14]?.value);
        setVilleResidence(infosData?.data[15]?.value);
        setSelectedPays(infosData?.data[16]);
      }
      if (infosData.type_personne == "PM") {
        setRaisonSocial(infosData?.data[0]);
        setContact(infosData?.data[1]);
        setEmail(infosData?.data[2]?.value);
        setTel(infosData?.data[3]?.value);
        setFax(infosData?.data[4]?.value);
        setAdresse(infosData?.data[5]?.value);
        setCode_postal(infosData?.data[6]?.value);
        setVille(infosData?.data[7]?.value);
        setPays(infosData?.data[8]);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const selectProfileState = (state) => state.Profile;
  const ProfileProperties = createSelector(selectProfileState, (profile) => ({
    error: profile.error,
    success: profile.success,
  }));

  const { error, success } = useSelector(ProfileProperties);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getTitre();
        await getData();

        await getPay();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    if (localStorage.getItem("authUser_" + api)) {
      const obj = localStorage.getItem("authUser_" + api);

      setTimeout(() => {
        // dispatch(resetProfileFlag());
        setLoading(false);
      }, 500);
    }
  }, [dispatch, success]);
  useEffect(() => {
    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      username: name || "",
      idx: idx || "",
      titre: selectedTitre || "",
      conseil: conseil || "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your UserName"),
      titre: Yup.string().required("res"),
    }),
    onSubmit: (values) => {
      dispatch(editProfile(values));
    },
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (infos.type_personne == "PP") {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/fdashboards/update_mes_infos`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              titre_id: selectedTitre?.value,
              nom: nom,
              prenom: prenom,
              date_de_naissance: dateNaissance,
              ville_de_naissance: lieuNaissance,
              departement_ou_pays: deptNaissance,
              profession: profession,
              adresse: adresseResidence,
              complement: complementAdresse,
              code_postal: codePostalResidence,
              ville: villeResidence,
              pay_id: selectedPays?.value,
              email: emailPerso,
              tel_fix: telephoneFixe,
              tel_mobil: telephoneMobile,
              email_pro: emailPro,
            }),
          }
        );

        if (response.ok) {
          console.log("Post request successful");
          handleNavigate();
        } else {
          console.error("Post request failed");
          const responseData = await response.json();

          if (responseData && responseData.reservation_validation) {
            // Si le champ "contact_validation" est présent dans la réponse JSON
            const errors =
              responseData?.contact_validation ||
              responseData?.investisseur_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
    if (infos.type_personne == "PM") {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/fdashboards/update_mes_infos`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              email: email,
              telephone: tel,
              fax: fax,
              adresse: adresse,
              code_postal: code_postal,
              ville: ville,
              pay_id: pays?.value,
            }),
          }
        );

        if (response.ok) {
          console.log("Post request successful");
          handleNavigate();
        } else {
          console.error("Post request failed");
          const responseData = await response.json();

          if (responseData && responseData.reservation_validation) {
            // Si le champ "contact_validation" est présent dans la réponse JSON
            const errors =
              responseData?.contact_validation ||
              responseData?.investisseur_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg="12">
              {error && error ? <Alert color="danger">{error}</Alert> : null}
              {success ? <Alert color="success">{success}</Alert> : null}

              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="ms-3">
                      <img
                        src={avatar}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center m-3">
                      <div className="text-muted">
                        <h5>Mes informations</h5>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {!loading && infos.type_personne == "PP" ? (
            <>
              <Card className="mb-4">
                <CardBody>
                  <Row>
                    <Col sm="6">
                      <Row className="mb-1">
                        <Col xs={12} md={12} lg={4} style={colStyle}>
                          <i style={{ color: "#9d9c9c" }}>
                            <span
                              style={{
                                display: "inline-block",
                                width: "11em",
                                paddingTop: "10px",
                              }}
                            >
                              Conseil agréé Dom Com :
                            </span>
                          </i>
                        </Col>
                        <Col xs={12} md={8} lg={4} style={colStyle}>
                          <input
                            className="form-control"
                            defaultValue={conseil?.value}
                            disabled
                          />
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col xs={12} md={12} lg={4} style={colStyle}>
                          <i style={{ color: "#9d9c9c" }}>
                            <span
                              style={{
                                display: "inline-block",
                                width: "11em",
                                paddingTop: "10px",
                              }}
                            >
                              Titre :
                            </span>
                          </i>
                        </Col>
                        <Col xs={12} md={8} lg={4} style={colStyle}>
                          <Select
                            defaultValue={selectedTitre}
                            onChange={handleTitreChange}
                            options={renderTitreOptions()}
                            isClearable={false}
                            className="select2"
                          />
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col xs={12} md={12} lg={4} style={colStyle}>
                          <i style={{ color: "#9d9c9c" }}>
                            <span
                              style={{
                                display: "inline-block",
                                width: "11em",
                                paddingTop: "10px",
                              }}
                            >
                              Nom:
                            </span>
                          </i>
                        </Col>
                        <Col xs={12} md={8} lg={4} style={colStyle}>
                          <input
                            className="form-control"
                            defaultValue={nom}
                            disabled
                          />
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col xs={12} md={12} lg={4} style={colStyle}>
                          <i style={{ color: "#9d9c9c" }}>
                            <span
                              style={{
                                display: "inline-block",
                                width: "11em",
                                paddingTop: "10px",
                              }}
                            >
                              Prenom :
                            </span>
                          </i>
                        </Col>
                        <Col xs={12} md={8} lg={4} style={colStyle}>
                          <input
                            className="form-control"
                            defaultValue={prenom}
                            disabled
                          />
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col xs={12} md={12} lg={4} style={colStyle}>
                          <i style={{ color: "#9d9c9c" }}>
                            <span
                              style={{
                                display: "inline-block",
                                width: "11em",
                                paddingTop: "10px",
                              }}
                            >
                              Date de naissance :
                            </span>
                          </i>
                        </Col>
                        <Col xs={12} md={8} lg={4} style={colStyle}>
                          <InputMask
                            mask="99/99/9999"
                            value={dateNaissance}
                            className="form-control input-color"
                            onChange={(dateString) => {
                              setDateNaissance(dateString.target.value);
                            }}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col xs={12} md={12} lg={4} style={colStyle}>
                          <i style={{ color: "#9d9c9c" }}>
                            <span
                              style={{
                                display: "inline-block",
                                width: "11em",
                                paddingTop: "10px",
                              }}
                            >
                              Lieu de naissance :
                            </span>
                          </i>
                        </Col>
                        <Col xs={12} md={8} lg={4} style={colStyle}>
                          <input
                            className="form-control"
                            defaultValue={lieuNaissance}
                            onChange={handleLieuNaissanceChange}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col xs={12} md={12} lg={4} style={colStyle}>
                          <i style={{ color: "#9d9c9c" }}>
                            <span
                              style={{
                                display: "inline-block",
                                width: "11em",
                                paddingTop: "10px",
                              }}
                            >
                              Dépt de naissance :
                            </span>
                          </i>
                        </Col>
                        <Col xs={12} md={8} lg={4} style={colStyle}>
                          <input
                            className="form-control"
                            defaultValue={deptNaissance}
                            onChange={handleDeptNaissanceChange}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col xs={12} md={12} lg={4} style={colStyle}>
                          <i style={{ color: "#9d9c9c" }}>
                            <span
                              style={{
                                display: "inline-block",
                                width: "11em",
                                paddingTop: "10px",
                              }}
                            >
                              Profession :
                            </span>
                          </i>
                        </Col>
                        <Col xs={12} md={8} lg={4} style={colStyle}>
                          <input
                            className="form-control"
                            defaultValue={profession}
                            onChange={handleProfessionChange}
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col sm="6">
                      <Row className="mb-1">
                        <Col xs={12} md={12} lg={4} style={colStyle}>
                          <i style={{ color: "#9d9c9c" }}>
                            <span
                              style={{
                                display: "inline-block",
                                width: "11em",
                                paddingTop: "10px",
                              }}
                            >
                              Email perso :
                            </span>
                          </i>
                        </Col>
                        <Col xs={12} md={8} lg={4} style={colStyle}>
                          <input
                            className="form-control"
                            defaultValue={emailPerso}
                            onChange={handleEmailPersoChange}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col xs={12} md={12} lg={4} style={colStyle}>
                          <i style={{ color: "#9d9c9c" }}>
                            <span
                              style={{
                                display: "inline-block",
                                width: "11em",
                                paddingTop: "10px",
                              }}
                            >
                              Email pro :
                            </span>
                          </i>
                        </Col>
                        <Col xs={12} md={8} lg={4} style={colStyle}>
                          <input
                            className="form-control"
                            defaultValue={emailPro}
                            onChange={handleEmailProChange}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col xs={12} md={12} lg={4} style={colStyle}>
                          <i style={{ color: "#9d9c9c" }}>
                            <span
                              style={{
                                display: "inline-block",
                                width: "11em",
                                paddingTop: "10px",
                              }}
                            >
                              Tel fixe :
                            </span>
                          </i>
                        </Col>
                        <Col xs={12} md={8} lg={4} style={colStyle}>
                          <input
                            className="form-control"
                            defaultValue={telephoneFixe}
                            onChange={handleTelephoneFixeChange}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col xs={12} md={12} lg={4} style={colStyle}>
                          <i style={{ color: "#9d9c9c" }}>
                            <span
                              style={{
                                display: "inline-block",
                                width: "11em",
                                paddingTop: "10px",
                              }}
                            >
                              Tel mobile :
                            </span>
                          </i>
                        </Col>
                        <Col xs={12} md={8} lg={4} style={colStyle}>
                          <input
                            className="form-control"
                            defaultValue={telephoneMobile}
                            onChange={handleTelephoneMobileChange}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col xs={12} md={12} lg={4} style={colStyle}>
                          <i style={{ color: "#9d9c9c" }}>
                            <span
                              style={{
                                display: "inline-block",
                                width: "11em",
                                paddingTop: "10px",
                              }}
                            >
                              Adresse résidence fiscale:
                            </span>
                          </i>
                        </Col>
                        <Col xs={12} md={8} lg={4} style={colStyle}>
                          <input
                            className="form-control"
                            defaultValue={adresseResidence}
                            onChange={handleAdresseResidenceChange}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col xs={12} md={12} lg={4} style={colStyle}>
                          <i style={{ color: "#9d9c9c" }}>
                            <span
                              style={{
                                display: "inline-block",
                                width: "11em",
                                paddingTop: "10px",
                              }}
                            >
                              Complément adresse :
                            </span>
                          </i>
                        </Col>
                        <Col xs={12} md={8} lg={4} style={colStyle}>
                          <input
                            className="form-control"
                            defaultValue={complementAdresse}
                            onChange={handleComplementAdresseChange}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col xs={12} md={12} lg={4} style={colStyle}>
                          <i style={{ color: "#9d9c9c" }}>
                            <span
                              style={{
                                display: "inline-block",
                                width: "11em",
                                paddingTop: "10px",
                              }}
                            >
                              Code postal :
                            </span>
                          </i>
                        </Col>
                        <Col xs={12} md={8} lg={4} style={colStyle}>
                          <input
                            className="form-control"
                            defaultValue={codePostalResidence}
                            onChange={handleCodePostalResidenceChange}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col xs={12} md={12} lg={4} style={colStyle}>
                          <i style={{ color: "#9d9c9c" }}>
                            <span
                              style={{
                                display: "inline-block",
                                width: "11em",
                                paddingTop: "10px",
                              }}
                            >
                              Ville :
                            </span>
                          </i>
                        </Col>
                        <Col xs={12} md={8} lg={4} style={colStyle}>
                          <input
                            className="form-control"
                            defaultValue={villeResidence}
                            onChange={handleVilleResidenceChange}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col xs={12} md={12} lg={4} style={colStyle}>
                          <i style={{ color: "#9d9c9c" }}>
                            <span
                              style={{
                                display: "inline-block",
                                width: "11em",
                                paddingTop: "10px",
                              }}
                            >
                              Pays :
                            </span>
                          </i>
                        </Col>
                        <Col xs={12} md={8} lg={4} style={colStyle}>
                          <Select
                            defaultValue={selectedPays}
                            onChange={handlePaysChange}
                            options={renderPayOptions()}
                            isClearable={false}
                            className="select2"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <div
                      className="text-center mt-3"
                      style={{ paddingBottom: 15 }}
                    >
                      {infos.can_update ? (
                        <Button onClick={handleSubmit} color="danger">
                          Mettre à jour mes informations
                        </Button>
                      ) : null}
                    </div>
                  </Row>
                </CardBody>
              </Card>
            </>
          ) : !loading && infos.type_personne == "PM" ? (
            <Card className="mb-4">
              <CardBody>
                <Row>
                  <Col sm="6">
                    <Row className="mb-1">
                      <Col xs={12} md={12} lg={4} style={colStyle}>
                        <i style={{ color: "#9d9c9c" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "11em",
                              paddingTop: "10px",
                            }}
                          >
                            Raison sociale :
                          </span>
                        </i>
                      </Col>
                      <Col xs={12} md={8} lg={4} style={colStyle}>
                        <input
                          className="form-control"
                          defaultValue={raisonSocial?.value}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className="mb-1">
                      <Col xs={12} md={12} lg={4} style={colStyle}>
                        <i style={{ color: "#9d9c9c" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "11em",
                              paddingTop: "10px",
                            }}
                          >
                            Contact :
                          </span>
                        </i>
                      </Col>
                      <Col xs={12} md={8} lg={4} style={colStyle}>
                        <input
                          className="form-control"
                          defaultValue={contact?.value}
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className="mb-1">
                      <Col xs={12} md={12} lg={4} style={colStyle}>
                        <i style={{ color: "#9d9c9c" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "11em",
                              paddingTop: "10px",
                            }}
                          >
                            Email :
                          </span>
                        </i>
                      </Col>
                      <Col xs={12} md={8} lg={4} style={colStyle}>
                        <input
                          className="form-control"
                          defaultValue={email}
                          onChange={handleEmailChange}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-1">
                      <Col xs={12} md={12} lg={4} style={colStyle}>
                        <i style={{ color: "#9d9c9c" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "11em",
                              paddingTop: "10px",
                            }}
                          >
                            Téléphone :
                          </span>
                        </i>
                      </Col>
                      <Col xs={12} md={8} lg={4} style={colStyle}>
                        <input
                          className="form-control"
                          defaultValue={tel}
                          onChange={handleTelChange}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-1">
                      <Col xs={12} md={12} lg={4} style={colStyle}>
                        <i style={{ color: "#9d9c9c" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "11em",
                              paddingTop: "10px",
                            }}
                          >
                            fax :
                          </span>
                        </i>
                      </Col>
                      <Col xs={12} md={8} lg={4} style={colStyle}>
                        <input
                          className="form-control"
                          defaultValue={fax}
                          onChange={handleFaxChange}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col sm="6">
                    <Row className="mb-1">
                      <Col xs={12} md={12} lg={4} style={colStyle}>
                        <i style={{ color: "#9d9c9c" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "11em",
                              paddingTop: "10px",
                            }}
                          >
                            Adresse :
                          </span>
                        </i>
                      </Col>
                      <Col xs={12} md={8} lg={4} style={colStyle}>
                        <input
                          className="form-control"
                          defaultValue={adresse}
                          onChange={handleAdresseChange}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-1">
                      <Col xs={12} md={12} lg={4} style={colStyle}>
                        <i style={{ color: "#9d9c9c" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "11em",
                              paddingTop: "10px",
                            }}
                          >
                            Code postal :
                          </span>
                        </i>
                      </Col>
                      <Col xs={12} md={8} lg={4} style={colStyle}>
                        <input
                          className="form-control"
                          defaultValue={code_postal}
                          onChange={handleCode_postalChange}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-1">
                      <Col xs={12} md={12} lg={4} style={colStyle}>
                        <i style={{ color: "#9d9c9c" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "11em",
                              paddingTop: "10px",
                            }}
                          >
                            Ville :
                          </span>
                        </i>
                      </Col>
                      <Col xs={12} md={8} lg={4} style={colStyle}>
                        <input
                          className="form-control"
                          defaultValue={ville}
                          onChange={handleVilleChange}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-1">
                      <Col xs={12} md={12} lg={4} style={colStyle}>
                        <i style={{ color: "#9d9c9c" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "11em",
                              paddingTop: "10px",
                            }}
                          >
                            Pays :
                          </span>
                        </i>
                      </Col>
                      <Col xs={12} md={8} lg={4} style={colStyle}>
                        <Select
                          defaultValue={pays}
                          onChange={handlePaysPMChange}
                          options={renderPayOptions()}
                          isClearable={false}
                          className="select2"
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <div
                    className="text-center mt-3"
                    style={{ paddingBottom: 15 }}
                  >
                    {infos.can_update ? (
                      <Button onClick={handleSubmit} color="danger">
                        Mettre à jour mes informations
                      </Button>
                    ) : null}
                  </div>
                </Row>
              </CardBody>
            </Card>
          ) : (
            <Spinners setLoading={setLoading} />
          )}
        </Container>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
{
  /*  */
}
